import React from 'react'
import Button from 'react-bootstrap/Button'
import Modal from "react-bootstrap/Modal"
import ProgressBar from 'react-bootstrap/ProgressBar'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'
import { ProcessStatus } from "../../../api/types"

export interface ProgressCounter {
  caption: string
  count: number
}

export interface ImportProgressModalProps {
  isOpen: boolean
  toggle: () => void
  fileName: string
  progress: number
  counters: Array<{
    caption: string;
    count: number
  }>
  status: ProcessStatus
  message: string | null
  errors: string[]
}

export default function ImportProgressModal(props: ImportProgressModalProps) {

  const handleClose = () => props.toggle();

  const statusToVariant = (status: ProcessStatus) => {
    switch (status) {
      case ProcessStatus.Running:
        return "info"
      case ProcessStatus.Completed:
        return "success"
      case ProcessStatus.Failed:
        return "danger"
      case ProcessStatus.Canceled:
        return "warning"
      default:
        return undefined
    }
  }

  return (
    <Modal
      show={props.isOpen}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>
          Importing feature catalog
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table borderless={true} size="sm">
          <tbody>
            <tr><td colSpan={2}>
              <ProgressBar variant={statusToVariant(props.status)} now={props.progress} label={`${props.progress}%`} />
            </td></tr>
            <tr><td>Filename</td><td className="text-end text-right">{props.fileName}</td></tr>
            {props.counters.filter(c => c.count > 0).map((c, i) => (
              <tr key={i}>
                <td>{c.caption}</td>
                <td className="text-end text-right">{c.count}</td>
              </tr>))}
            <tr><td colSpan={2}>{props.errors.map((m, i) => 
              <div key={i} className="text-danger">{m}</div>
            )}</td></tr>
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <div className={`flex-fill text-${statusToVariant(props.status)}`}>{props.message}</div>
        {props.status === ProcessStatus.Running ? (
          <Spinner animation="border" role="status" />
        ) : (
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          )
        }
        </Modal.Footer>
    </Modal>
  );
}